module.exports = __webpack_public_path__ + "img/icon-wx.1612aff8.svg";